import { render, staticRenderFns } from "./c2.vue?vue&type=template&id=31cd9de6&scoped=true"
import script from "./c2.vue?vue&type=script&lang=js"
export * from "./c2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd9de6",
  null
  
)

export default component.exports